export const GET_GRADES = 'GET_GRADES'
export const GET_GRADE = 'GET_GRADE'
export const DELETE_GRADE = 'DELETE_GRADE'
export const ADD_GRADE = 'ADD_GRADE'
export const DELETE_MANY_GRADES = 'DELETE_MANY_GRADE'
export const UPDATE_GRADE = 'UPDATE_GRADE'
export const REDUX_GET_GRADES = 'REDUX_GET_GRADES'
export const GET_SUBJECT_GRADES = 'GET_SUBJECT_GRADES'
export const UPDATE_GRADES_SEQUENCE = 'UPDATE_GRADES_SEQUENCE'
